import global from "../global.js";
const log = global.log.getLogger("f_mtac.ui.AlertArea");
log.setLevel(log.levels.WARN);

let AlertArea = function () {
    var $alert_area = document.getElementById("alert_area");
    var {Modal} = window.f_mtac_theme;
    var alert_area_modal = new Modal($alert_area);

    // type: Set the alert style from theme-colors (eg: success, info, warning, danger, etc.)
    this.interact = function ({tip1 = "", tip2 = "", type = "info"}) {
        $("#alert_area p.tip1").html(tip1); // AGPOC-4659: use .html() for special characters
        $("#alert_area p.tip2").html(tip2);
        $("#alert_area .alert").addClass(`alert-${type}`);
        return new Promise((resolve) => {
            const interaction_end = () => {
                log.debug("AlertArea.interaction_end");
                $("#alert_area .alert").removeClass(`alert-${type}`);
                $alert_area.removeEventListener("hidden.bs.modal", interaction_end);
                resolve();
            };
            $alert_area.addEventListener("hidden.bs.modal", interaction_end);
            alert_area_modal.show();
        });
    };

    this.hide = () => alert_area_modal.hide();
};
export default new AlertArea();
